import React, { useState } from "react";
import styled from "styled-components";
import { RightOutlined, DownOutlined } from "@ant-design/icons";

interface CollapsibleProps {
  isVisible: boolean;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 65%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
`;

const CollapseButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  width: 100%;
  border-radius: 4px;
  background-color: #f8f8f8;
  color: black;
  border: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const CollapsibleContent = styled.div<CollapsibleProps>`
  max-height: ${props => (props.isVisible ? "800px" : "0")};
  margin-left: 1rem;
  overflow: hidden;
  transition: max-height 0.3s ease;
`;

const EventContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const SmallText = styled.p`
  margin-top: 0;
  margin-bottom: 0;
  color: #595959;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
`;

const FormBox = styled.div`
  margin-bottom: 10px;
  width: 100%;
`;

const ImagePreview = styled.img`
  max-width: 100%;
  max-height: 200px;
  border-radius: 8px;
`;

const DetailItem = styled.div`
  margin-bottom: 16px;
`;

const DetailLabel = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
  color: #595959;
`;

const DetailValue = styled.div`
  padding: 8px;
  background-color: #f5f5f5;
  border-radius: 4px;
`;

type EventDetailsProps = {
  event: any;
};

const EventDetails: React.FC<EventDetailsProps> = ({ event }) => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <Container>
      <CollapseButton onClick={toggleVisibility}>
        Event Details
        {isVisible ? <DownOutlined /> : <RightOutlined />}
      </CollapseButton>

      <CollapsibleContent isVisible={isVisible}>
        <EventContainer>
          <Top>
            <SmallText>Event Banner</SmallText>
            {event?.banner && <ImagePreview src={event.banner} alt="Event Banner" />}
          </Top>

          <DetailItem>
            <DetailLabel>Event Title</DetailLabel>
            <DetailValue>{event?.title || "Not specified"}</DetailValue>
          </DetailItem>

          <DetailItem>
            <DetailLabel>Organizer</DetailLabel>
            <DetailValue>{event?.organizerEmail || "Not specified"}</DetailValue>
          </DetailItem>

          <DetailItem>
            <DetailLabel>Event Category</DetailLabel>
            <DetailValue>{event?.category || "Not specified"}</DetailValue>
          </DetailItem>

          <DetailItem>
            <DetailLabel>About Event</DetailLabel>
            <DetailValue>{event?.about || "Not specified"}</DetailValue>
          </DetailItem>
        </EventContainer>
      </CollapsibleContent>
    </Container>
  );
};

export default EventDetails;
